import Rollbar from 'rollbar';
import rollbarConfig from "../../rollbar.cofig";

export default function (Vue) {
    // Set the Rollbar instance in the Vue prototype
    // before creating the first Vue instance.
    // This ensures it is available in the same way for every
    // instance in your app.
    Vue.prototype.$rollbar = new Rollbar(rollbarConfig);

    // If you have already set up a global error handler,
    // just add `vm.$rollbar.error(err)` to the top of it.
    // If not, this simple example will preserve the app’s existing
    // behavior while also reporting uncaught errors to Rollbar.
    Vue.config.errorHandler = (err, vm) => {
        vm.$rollbar.error(err);
        throw err; // rethrow
    };
}